import { createFileRoute } from '@tanstack/react-router'
import { USMap } from '@/features/maps/components/us-map'
import { Main } from '@/components/layout/main'

export const Route = createFileRoute('/_authenticated/maps/')({
    component: MapPage,
})

function MapPage() {
    return (
        <>
            {/* ===== Main ===== */}
            <Main fluid>
                <div className='mb-2 flex items-center justify-between space-y-2'>
                    <h1 className='text-2xl font-bold tracking-tight'>US Vector Map</h1>
                </div>
                <div className='relative h-[calc(100vh-12rem)] min-h-[500px] w-full overflow-hidden rounded-lg border'>
                    <USMap />
                </div>
            </Main>
        </>
    )
}
